import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  createAndSendOtp } from
"../../services/epic/bloodDonation";
import MobileNumberVerificationPopup from "./MobileNumberVerificationPopup";
import Cookies from "js-cookie";
import { config } from "../../utils/constants";
import {
  setLocalStorage,
  isValidUAENumber } from
"../../utils/util";
import AlertDependent from "../../common/AlertDependent";
import { Loader } from "../../common/Loader";
import { getCurrentLocale } from "../../utils/util";
import formatMobileNumber from "../../common/FormatMobileNumber";

const MakeBloodDonation = ({
  setRequestStep,
  mobileNum,
  setMobileNumber,
  isLiferay,
  showLogin,
  userDetailsLiferay,
  fetchUpcomingDonationDetailsByMobileNo,
  cardProfile,
  translationMap
}) => {
  const [mobileNumberVerificationPupup, setMobileNumberVerificationPupup] =
  useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const navigate = useNavigate();
  const [locale, setLocale] = useState("");

  useEffect(() => {
    userDetailsLiferay();
    const local = getCurrentLocale();
    setLocale(local);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 9) {
      setPhoneNumber(value);
      setMobileNumber(value);
      if (value.length === 0) {
        setErrorMessage("");
        setIsButtonEnabled(false);
      } else if (value.length === 9 && isValidUAENumber(value)) {
        setErrorMessage("");
        setIsButtonEnabled(true);
      } else if (value.length === 9) {
        setErrorMessage(
          translationMap?.pleaseEnterValidUAENO
        );
        setIsButtonEnabled(false);
      } else {
        setErrorMessage(
          translationMap?.mobileNoMustBeTen
        );
        setIsButtonEnabled(false);
      }
    } else {
      e.preventDefault();
    }
  };

  const getGeneratedOtpForBloodDonation = async () => {
    setOtpError(false);
    setIsLoading(true);
    let cleanMobileNo = formatMobileNumber(mobileNum);
    setMobileNumber(cleanMobileNo);
    const info = await createAndSendOtp(cleanMobileNo);
    setIsLoading(false);
    if (info?.data?.message === "otpBlocked")
    {
      setOtpError(true);
      return;
    } else
    {
      const idInfo = info?.data?.id;
      setId(idInfo);
      // setIsLoading(false);
      setMobileNumberVerificationPupup(true);
    }
  };

  const handleLogin = () => {
    setLocalStorage("loginAccount", "makeABloodDonation");
    Cookies.set("lastPath", "blood-donation");
    Cookies.set("LangPref", locale);
    //console.log("Cookie set successfully!");
  };

  const currentPagePath =
  window &&
  window.Liferay &&
  window.Liferay.ThemeDisplay.getLanguageId() !== "en_US" ?
  "/blood-donation" :
  "/ar/blood-donation";

  if (isLoading) {
    return (
      <Loader />);

  }
  return (
    <>
            <section
        className="w-100 clearfix BloodDonationMainSection"
        id="CoverPlanActive">
        
                <div className="container customContainer">
                    <div className="Title_Inner_Box">
                        <h6 className="MainTitleOne">
                            {translationMap?.makeABloodDonation}
                        </h6>
                    </div>
                    <div className="cover_inner_wrapper">
                        <div className="cover_main_box1">

                                {!cardProfile && isLiferay &&
              <>
                                        {showLogin ?
                <>
                                                <div className="donation_form_title_box donation_form_title_box_bgshadow">
                                                <p className="Gray_Title">
                                                    {translationMap?.wantToLoginAcc}
                                                </p>
                                                <div className="btn_box">

                                                        <form
                        id="loginForm"
                        method="post"
                        action="/home/-/login/openid_connect_request?p_p_state=maximized">
                        
                                                            <input
                          type="hidden"
                          name="_com_liferay_login_web_portlet_LoginPortlet_oAuthClientEntryId"
                          value={config.idamClientId} />
                        
                                                            <input
                          type="hidden"
                          name="_com_liferay_login_web_portlet_LoginPortlet_redirect"
                          value={currentPagePath} />
                        
                                                            <button
                          type="submit"
                          className="btn btn-outline-primary mb-3 bluetrans_btn_link d-none d-md-block"
                          onClick={handleLogin}>
                          
                                                                {translationMap?.login}
                                                            </button>

                                                            <a href={config.bloodDonationLoginUrl} type="submit" className="btn btn-outline-primary mb-3 bluetrans_btn_link d-md-none" data-uw-rm-kbnav="anohref" tabindex="0">{translationMap?.login}</a>
                                                        </form>
                                              

                                                </div>
                                                <p className="Gray_Title">
                                                    {translationMap?.proceedUsingUAENo}
                                                </p>
                                                </div>
                                            </> :

                <>
                                                <div className="donation_form_title_box donation_form_title_box_bgshadow">
                                                <p className="Gray_Title">
                                                    {translationMap?.wantToLinkDonorAcc}
                                                </p>
                                                <div className="btn_box">
                                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                    <a
                        className="bluetrans_btn_link"
                        onClick={() => navigate("/link-account")}>
                        
                                                        {translationMap?.linkAccount}
                                                    </a>
                                                </div>
                                                <p className="Gray_Title">
                                                    {translationMap?.proceedUsingUAENo}
                                                </p>
                                                </div>
                                            </>
                }
                                    </>
              }

                            <div className="dependent_form_box">
                                <div className="inner_title_txt_box"></div>
                                {otpError &&
                <AlertDependent setError={setOtpError} alert_text={translationMap?.otpBlocked} />
                }
                                <form onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    document.getElementById("continueButton")?.click();
                  }
                }}>
                                    <div className="form_inner_box">
                                        <div className="inner_input_box">
                                            <div className="custom_input_box">
                                                <div className="input_box">
                                                    <label>{translationMap?.phoneNo}</label>
                                                    <div className="input number_input_field">
                                                        <input
                              type="text"
                              className="input_field"
                              inputmode="numeric"
                              value={phoneNumber}
                              onChange={handleChange}
                              placeholder="5xx xxx xxx"
                              style={{
                                borderColor: errorMessage ?
                                "#FF8F8A" :
                                "rgb(128 153 178)"
                              }} />
                            
                                                        <span className="input-group-addon" style={{ direction: "ltr" }}>+971</span>
                                                        {errorMessage &&
                            <span id="text" style={{ color: "#FF8F8A" }}>
                                    {errorMessage}
                                  </span>
                            }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form_btn_box">
                        <span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                        id="continueButton"
                        className={
                        !isButtonEnabled ?
                        "disabled_btn_link" :
                        "bluetrans_btn_link"
                        }
                        onClick={getGeneratedOtpForBloodDonation}>
                        
                            {translationMap?.continueBloodDonation}
                          </a>
                        </span>
                                        <span>
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a
                        className="bluetrans_btn_link"
                        onClick={() => {
                          setRequestStep(-1);
                          window.parent.scrollTo(0, 0);
                        }}>
                        
                            {translationMap?.back}
                          </a>
                        </span>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="cover_main_box2"></div>
                    </div>
                </div>
            </section>
            {mobileNumberVerificationPupup &&
      <MobileNumberVerificationPopup
        setRequestStep={setRequestStep}
        setMobileNumberVerificationPupup={setMobileNumberVerificationPupup}
        mobileNum={mobileNum}
        fetchUpcomingDonationDetailsByMobileNo={fetchUpcomingDonationDetailsByMobileNo}
        setIsLoading={setIsLoading}
        id={id}
        translationMap={translationMap} />

      }
        </>);

};

export default MakeBloodDonation;